import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ESkeletonType } from '@norfolk-southern/accessns-components';
import Swal, { SweetAlertResult } from 'sweetalert2';

import { NSMessages } from '@ruby/configs/messages.constants';
import { EColors } from '@ruby/shared/enums/colors.enums';
import { EDiversionsActionType, EDiversionsTypes } from '@ruby/shared/enums/diversions.enum';
import { IDiversionsRequestSummary, IDiversionsWaybillDetail } from '@ruby/shared/models/diversions/diversions.interface';

@Component({
  selector: 'ng-request-detail',
  templateUrl: './request-detail.component.html',
  styleUrls: ['./request-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RequestDetailComponent {
  @Input() form!: UntypedFormGroup;
  @Input() status?: string;
  @Input() stored?: number;
  @Input() updated?: number;
  @Input() userId?: string;
  @Input() userName?: string;
  @Input() requestNumber?: string;
  @Input() waybillSerial?: string;
  @Input() waybillType!: string;
  @Input() loading!: boolean;
  @Input() requestSummary?: IDiversionsRequestSummary;
  @Input() rejectSummary?: IDiversionsRequestSummary;
  @Input() completeSummary?: IDiversionsRequestSummary;
  @Input() waybillDetail?: IDiversionsWaybillDetail;
  @Output() cancelDiversion = new EventEmitter();
  @Output() rejectDiversion = new EventEmitter();
  @Output() completeDiversion = new EventEmitter();
  types: typeof EDiversionsTypes = EDiversionsTypes;
  actions: typeof EDiversionsActionType = EDiversionsActionType;
  skeleton: ESkeletonType = ESkeletonType.GRID;

  constructor() { }

  /**
   * Confirm Before Cancel Dialog
   *
   * @summary Open confirmation dialog before canceling a diversion
   * @returns void
   */
  confirmBeforeActionDialog(param: string): void {
    const title = param === EDiversionsActionType.CANCEL ?
      NSMessages.diversionsPrevRequestConfirmCancel :
      param === EDiversionsActionType.REJECT ?
        NSMessages.diversionsPrevRequestConfirmReject : NSMessages.diversionsPrevRequestConfirmComplete;
    Swal.fire({
      title: `${ title } ${ this.requestNumber }?`,
      icon: 'warning',
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonColor: EColors.DANGER_DARK,
      cancelButtonText: 'NO',
      confirmButtonText: 'YES',
      confirmButtonColor: EColors.GOLD,
      heightAuto: false
    }).then((response: SweetAlertResult) => {
      if (response.isConfirmed) {
        switch (param) {
          case EDiversionsActionType.CANCEL: {
            this.cancelDiversion.emit();
            break;
          }
          case EDiversionsActionType.REJECT: {
            this.rejectDiversion.emit();
            break;
          }
          case EDiversionsActionType.COMPLETE: {
            this.completeDiversion.emit();
            break;
          }
        }
      }
    });
  }
}
